export const manual = 'https://imgameapp.ru/manual'
